<template>
  <div class="live-content">
    <div
      class="live-content__background"
      data-in-out
      data-in-out-animation="fade"
      data-in-out-no-menu
    ></div>
    <div class="live-content__container" data-in-out data-in-out-animation="fade" data-in-out-no-menu>
      <div class="live-content__block">
        <LivePicture picture-id="1" />
        <div class="live-content__block-text" data-medusa data-picture="1">
          <strong>Cuvée 1821 </strong> means to<em> be contemporary, </em> today.
        </div>
      </div>
      <div class="live-content__block">
        <LivePicture picture-id="2" />
        <div class="live-content__block-text" data-medusa data-picture="2">
          <strong>It means</strong><em> being concrete and aware</em>, without the need to be always serious.
        </div>
      </div>
      <div class="live-content__block">
        <LivePicture picture-id="3" />
        <div class="live-content__block-text" data-medusa data-picture="3">
          <strong>It means</strong><em> having roots and being cosmopolitan</em>,
          curious and open to authentic relationships.
        </div>
      </div>
      <div class="live-content__block">
        <LivePicture picture-id="4" />
        <div class="live-content__block-text" data-medusa data-picture="4">
          <strong>It means</strong> to <em>be practical and aim at the heart of things</em>,to love what’s well crafted, without frills.
        </div>
      </div>
      <div class="live-content__block">
        <LivePicture picture-id="5" />
        <div class="live-content__block-text" data-medusa data-picture="5">
          <strong>It means</strong> to <em>be spontaneously interesting</em> and quick- minded, without the need to show off.
        </div>
      </div>
      <div class="live-content__block">
        <LivePicture picture-id="6" />
        <div class="live-content__block-text" data-medusa data-picture="6">
          <strong>Who embodies</strong> <strong>Cuvée 1821</strong> knows how to <em>embrace the present and become an integral part of it</em> without casting his own identity aside.
        </div>
      </div>
      <div class="live-content__block">
        <div class="live-content__block-text" data-medusa>
          <strong>It says</strong> #Live<em>Your</em>Moment
        </div>
      </div>
      <div class="live-content__block">
        <div class="live-content__block-text" data-medusa>
          consciously <em>enjoy the meaningful moments of life, whenever and wherever.</em>
        </div>
      </div>
    </div>

    <MobileFooter />
  </div>
</template>

<script>
import { TweenLite } from 'gsap/TweenMax';
import Medusa from '@adoratorio/medusa';
import engine from '@/scripts/engine';
import scroll from '@/scripts/scroll';
import medusa from '@/scripts/medusa';
import LivePicture from '@/components/contents/LivePicture.vue';
import MobileFooter from '@/components/MobileFooter.vue';
import { SplitText } from '../../scripts/libs/SplitText';
import animations from '../../assets/animations';

export default {
  name: 'LiveContent',

  components: {
    LivePicture,
    MobileFooter,
  },

  mounted() {
    engine.add(this.scroll, 'live-scroll', true);
    medusa.ref.addTarget({
      id: 'medusa-live',
      container: document,
      nodes: Array.from(this.$el.querySelectorAll('[data-medusa]')),
      callback: this.medusa,
      mode: Medusa.MODE.DEFAULT,
      threshold: 0,
      offsets: '-200px 0px -200px 0px',
    });
    const textBlocks = Array.from(this.$el.querySelectorAll('.live-content__block-text[data-medusa]'));
    textBlocks.forEach((block) => {
      TweenLite.set(block, { opacity: 0.01 });
    });
    this.$nextTick(() => scroll.setBoundries(this.$el));
  },

  methods: {
    scroll() {
      scroll.checkIsScrolled(200);
      this.$el.style.transform = `translateY(-${scroll.ref.amount.y}px)`;
    },
    medusa(target) {
      if (target.isIntersecting) {
        if (target.target.dataset.animated === 'done') return;
        target.target.dataset.animated = 'done';
        const s = new SplitText(target.target, { type: 'words, chars', charsClass: 'live-content__block-char' });
        TweenLite.set(s.chars, { y: 40, autoAlpha: 0 });
        animations.get('text-enter')(target.target).play();
        TweenLite.set(target.target, { opacity: 1 });
        target.target.split = s;
      } else {
        if (target.target.split) target.target.split.revert();
      }
    },
    enter(event) {
      this.$eventHub.$emit('picture-hover', { id: event.target.dataset.picture });
    },
    leave(event) {
      this.$eventHub.$emit('picture-leave', { id: event.target.dataset.picture });
    },
  },

  beforeDestroy() {
    engine.remove('live-scroll');
    medusa.ref.removeTarget('medusa-live');
    this.$store.commit('SET_PAGE_SCROLLED', false);
  },
};
</script>

<style lang="scss" scoped>
.live-content {
  padding-top: 100vh;
  padding-top: calc(var(--vh, 1vh) * 100);
  color: $color-dark;

  @include mq($until: ipadL) {
    padding-top: 90vh;
    padding-top: calc(var(--vh, 1vh) * 90);
  }

  &__background {
    @extend %full;
    background-color: $color-white;
  }

  &__container {
    position: relative;
    width: calc(100% - ((100vw / 32) * 12));
    left: calc((100vw / 32) * 6);
    padding-bottom: calc((100vh / 18) * 2);

    @include mq($until: ipadL) {
      width: calc(100% - ((100vw / 32) * 8));
      left: calc((100vw / 32) * 4);
      padding-bottom: 0px;
    }
  }

  &__block {
    position: relative;
    font-size: rem(120px);
    font-size: calc(120px * var(--rw));
    line-height: rem(110px);
    line-height: calc(110px * var(--rw));
    text-transform: uppercase;
    margin: calc(200px * var(--rw)) 0px;

    @include mq($until: ipadL) {
      font-size: rem(40px);
      font-size: calc(40px * var(--rw));
      line-height: rem(38px);
      line-height: calc(38px * var(--rw));
    }

    &:first-child {
      @include mq($until: ipadL) {
        margin-top: 0px;
      }
    }

    &-text {
      position: relative;
      z-index: 2;
      mix-blend-mode: multiply;
      box-sizing: border-box;
    }

    .live-picture {
      position: absolute;
      width: calc(720px * var(--rw));
      height: calc(480px * var(--rw));
      bottom: calc(-300px * var(--rw));
      left: 50%;
      margin-left: calc((-720px / 2) * var(--rw));
      z-index: 1;

      @include mq($until: ipadL) {
        width: calc(360px * var(--rw));
        height: calc(240px * var(--rw));
        bottom: calc(-180px * var(--rw));
        margin-left: calc((-360px / 2) * var(--rw));
      }
    }

    span.bold,
    strong {
      font-size: rem(130px);
      font-size: calc(130px * var(--rw));
      line-height: 0px;
      font-family: 'IGT Frankling Gothic';
      font-weight: 600;

      @include mq($until: ipadL) {
        font-size: rem(44px);
        font-size: calc(44px * var(--rw));
      }
    }

    span.teal,
    em {
      color: $color-primary;
      font-style: normal;
    }

    span.italic {
      font-style: italic;
      font-weight: normal;
      font-weight: 300;
    }
  }
}
</style>
